const accordion = {
  root: {
    width: '100%',
    transitionDuration: '{transition.duration}',
  },
  panel: {
    borderWidth: '0',
    borderRadius: '{spacing.xs}',
    shadow: '0 0 {spacing.xs} 0 #00000033',
  },
  header: {
    padding: '{spacing.ss} {spacing.s}',
    fontWeight: '700',
    borderWidth: '0',
    borderColor: '{content.border.color}',
    hoverBackground: '{grayScale.100}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    toggleIcon: {
      color: '{text.muted.color}',
    },
    first: {
      topBorderRadius: '{content.border.radius}',
      borderWidth: '0',
    },
    last: {
      bottomBorderRadius: '{content.border.radius}',
      activeBottomBorderRadius: '0',
    },
  },
  content: {
    borderWidth: '0',
    borderColor: '{content.border.color}',
    background: '{content.background}',
    padding: '0 {spacing.s} {spacing.ss} {spacing.s}',
  },
};

export default accordion;
